package de.xtl.retroguide

import web.dom.document
import web.html.HTMLAnchorElement

internal actual fun downloadMarkdown(fileName: String, content: String) {
    val blob = js("new Blob([content], { type: 'text/markdown;charset=utf-8' })")
    val url = js("URL.createObjectURL(blob)") as String
    (document.createElement("a") as HTMLAnchorElement).apply {
        href = url
        download = fileName
        click()
    }
    js("URL.revokeObjectURL(url)")
}

internal actual fun shareMarkdown(fileName: String, content: String) {
    js("navigator.share ? navigator.share({ title: fileName, text: content }).catch(function() {}) : (navigator.clipboard ? navigator.clipboard.writeText(content) : undefined)")
}
